import { ImageFileIcon, ImageFileIconProps } from "../ImageFileIcon"

export const DarkMapIcon = ({ containerClasses, iconSize }: ImageFileIconProps) => {
    return (
        <ImageFileIcon
            id="Dark-map-icon"
            imageFilePath="/images/maps/dark.jpg"
            containerClasses={containerClasses}
            iconSize={iconSize}
        />
    )
}

export default DarkMapIcon
